import React from "react";

import Categoriproduct from "../components/ui/Categoriproduct";

const Harddrinks = () => {
  return (
    <div>
      <Categoriproduct />
    </div>
  );
};

export default Harddrinks;
